<p-toast key="info" [style]="{marginTop: '80px'}"></p-toast>
<p-toast position="center" key="conf" (onClose)="onReject()" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div style="text-align: center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3em"></i>
            <h3>{{message.summary}}</h3>
            <p>{{message.detail}}</p>
        </div>
        <div class="ui-g ui-fluid">
            <div class="ui-g-6">
                <button type="button" pButton (click)="onConfirm()" label="Yes" class="ui-button-success"></button>
            </div>
            <div class="ui-g-6">
                <button type="button" pButton (click)="onReject()" label="No" class="ui-button-secondary"></button>
            </div>
        </div>
    </ng-template>
</p-toast>
<p-confirmDialog key="confDialog" header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-confirmDialog key="confDialog2" [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text"></p-confirmDialog>

<h6 class="prd-h6"> View/Print Notices </h6>
<div class="card" >
    <div class="card-body" *ngIf='displayState.workingDiv'>
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
<br />
<div class="row" *ngIf='displayState.gridDiv'>
    <div class="col-md-10 offset-1">
      <p-table [value]="hearingDateList" [scrollable]="true" scrollHeight="570px"  >
        <ng-template pTemplate="header">
            <tr style="font-size:medium;">
                <th style="width: 20%;">Hearing Date</th>
                <th style="width: 20%;">Type</th>
                <th style="width: 10%;"># of Cases</th>
                <th style="width: 10%;" >&nbsp;</th>
                <th style="width: 10%;" >&nbsp;</th>
                <th style="width: 10%;" >&nbsp;</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-hearing>
            <tr style="font-size: small;">
                <td style="width: 20%;">{{hearing.hearingDate | date:"MM/dd/yyyy"}} {{hearing.hearingTime}}</td>
                <td style="width: 20%;">{{hearing.noticeType}}</td>
                <td style="width: 10%;">{{hearing.noticeCount}}</td>
                <td style="width: 10%;">
                    <button class='btn btn-sm btn-link' (click)="printNotices(hearing)">Print Notices</button>
                </td>
                <td style="width: 10%;">
                    <button class='btn btn-sm btn-link' (click)="chooseLabels(hearing)">Labels</button>
                </td>
                <td style="width: 10%;">
                    <button class='btn btn-sm btn-link' (click)="updateStatuses(hearing)">Update Statuses</button>
                </td>
            </tr>
        </ng-template>
      </p-table>
    </div>
</div>
<br />
<div *ngIf="displayState.labelDiv">
  <div class="row">
    <div class="col-md-10 offset-1">
      <p-table [columns]="cols" [value]="labelsList" [responsive]="true" [scrollable]="true" scrollHeight="230px"
               [(selection)]="selectedLabelsList" >
        <ng-template pTemplate="caption">
          <h6><label>Select Labels to be Printed</label></h6>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width: 3%;">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th [pSortableColumn]="'row1'" style="width: 20%;">{{ cols[0].header }} <p-sortIcon [field]="'row1'"></p-sortIcon></th>
            <th [pSortableColumn]="'row2'" style="width: 20%;">{{ cols[1].header }} <p-sortIcon [field]="'row2'"></p-sortIcon></th>
            <th [pSortableColumn]="'row3'" style="width: 25%;">{{ cols[2].header }} <p-sortIcon [field]="'row3'"></p-sortIcon></th>
            <th [pSortableColumn]="'row4'" style="width: 10%;">{{ cols[3].header }} <p-sortIcon [field]="'row4'"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pLabel>
          <tr [pSelectableRow]="pLabel">
            <td style="width: 3%;">
              <p-tableCheckbox [value]="pLabel"></p-tableCheckbox>
            </td>
            <td style="width: 20%;">{{ pLabel.row1 }}</td>
            <td style="width: 20%;">{{ pLabel.row2 }}</td>
            <td style="width: 25%;">{{ pLabel.row3 }}</td>
            <td style="width: 10%;">{{ pLabel.row4 }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="row" >
            <div class="col-md-2 offset-1" style="text-align: left;"># of labels: {{ labelsList?.length }}</div>
            <div class="col-md-3 offset-1" style="text-align: left;"># of selected labels: {{ +selectedLabelsList?.length }}</div>
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-md-2 offset-5">
      <button class="btn btn-sm btn-info" title="Print SELECTED labels" (click)="printLabels()" >Print Selected Labels</button>
      <span>&nbsp;&nbsp;</span>
      <button class="btn btn-sm btn-secondary" title="Cancel printing of labels" (click)="cancelLabelChoose()" >Cancel</button>
    </div>
  </div>
</div>
